import { Download, ShoppingCart, Clock } from "lucide-react";

const steps = [
  {
    number: 1,
    icon: Download,
    title: "Baixe o e-book",
    description: "Salve no seu celular ou computador para ter sempre à mão"
  },
  {
    number: 2,
    icon: ShoppingCart,
    title: "Abra a Lista de Compras",
    description: "Tem tudo para o mês inteiro, organizado e sem desperdício"
  },
  {
    number: 3,
    icon: Clock,
    title: "Escolha a receita de hoje",
    description: "Almoce em até 30 minutos com ingredientes simples"
  }
];

const QuickSteps = () => {
  return (
    <section className="py-12 md:py-16 bg-muted/30">
      <div className="container">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-4">
            Comece em 3 passos (agora mesmo)
          </h2>
          <p className="text-center text-muted-foreground mb-12 max-w-2xl mx-auto">
            Dica: favorite esta página e <strong>adicione nosso contato</strong> no WhatsApp para receber futuras atualizações e dicas.
          </p>

          <div className="grid md:grid-cols-3 gap-6">
            {steps.map((step) => {
              const Icon = step.icon;
              return (
                <div
                  key={step.number}
                  className="bg-background rounded-lg p-6 border border-border hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
                >
                  {/* Step number badge */}
                  <div className="flex items-center gap-4 mb-4">
                    <div className="flex-shrink-0 w-12 h-12 rounded-full bg-gradient-warm flex items-center justify-center text-white font-bold text-lg">
                      {step.number}
                    </div>
                    <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
                      <Icon className="h-5 w-5 text-primary" />
                    </div>
                  </div>

                  <h3 className="text-lg font-semibold mb-2">{step.title}</h3>
                  <p className="text-sm text-muted-foreground">{step.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default QuickSteps;
